import { addDays, startOfDay } from 'date-fns';

export function getMinPausePeriodStartAt(canCreatePauseFrom: string | Date): Date {
  const from = new Date(canCreatePauseFrom);
  const dayStart = startOfDay(from);

  if (from.getTime() > dayStart.getTime()) {
    return addDays(dayStart, 1);
  }

  return dayStart;
}
